import { axios } from './client'
import { ProjectType, ProjectUserRolesType } from '../types';

export const getProject = async (id: any): Promise<ProjectType> => {
    try {
        return  await axios.get(`project/${id}`).then(response => response.data)
    } catch (error) {
        return Promise.reject(error);
    }
}
export const getProjectUserRoles = async (id: any): Promise<ProjectUserRolesType> => {
    try {
        return  await axios.get(`project/${id}/user-roles`)
        // return roles;
    } catch (error) {
        return Promise.reject(error);
    }
}
export const getProjects = async (): Promise<ProjectType[]> => {
    try {
        return  await axios.get(`project/15`).then(response => response.data);
    } catch (error) {
        return Promise.reject(error);
    }
}

